<ix-fieldset [title]="'OAuth Authentication' | translate" [formGroup]="form">
  <button
    class="login-button"
    mat-button
    type="button"
    ixTest="log-in-to-provider"
    (click)="onLoginPressed()"
  >
    {{ 'Log In To Provider' | translate }}
  </button>

  <ix-input
    formControlName="client_id"
    [label]="'OAuth Client ID' | translate"
  ></ix-input>

  <ix-input
    formControlName="client_secret"
    type="password"
    [label]="'OAuth Client Secret' | translate"
  ></ix-input>
</ix-fieldset>
